import Division from "@/pages/administrer/configuration/divisions/Division.vue";
import CreateDivision from "@/pages/administrer/configuration/divisions/CreateDivision.vue";
import ShowDivision from "@/pages/administrer/configuration/divisions/ShowDivision.vue";

export default [ {
    path: 'divisions',
    meta: { permissions: ["view_division"] },
    name: "AdminConfigDivision",
    component: Division
},
{
    path: 'divisions/create',
    meta: { permissions: ["create_division"] },
    name: "AdminConfigCreateDivision",
    component: CreateDivision
},
{
    path: 'divisions/:id/show',
    meta: { permissions: ["view_any_division"] },
    name: "AdminConfigShowDivision",
    component: ShowDivision
}]